<template>
  <div class="container col-11 m-3 my-4">
    <div class="flex-shrink-0 d-block d-lg-none me-3">
      <a @click="test" class="user-chat-remove font-size-18 p-1 px-2 btn btn-primary">
        <i class="fa-solid fa-chevron-left align-middle"></i>
      </a>
    </div>
    <div
      class="tab-pane"
      id="pills-search"
      role="tabpanel"
      aria-labelledby="pills-search-tab"
      v-bind:class="$route.name == 'search' ? 'active' : ''"
    >
      <div class="container-fluid card text-body">
        <form class="mt-4 col-12">
          <label for="basic-url" class="form-label h4"
            >Search for a Topic or a User</label
          >
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              id="serachChatUser"
              v-model="serach"
              placeholder="Topics or Username..."
              aria-label="Search"
              aria-describedby="searchbtn-addon"
              autocomplete="off"
            />
            <button
              class="btn btn-primary"
              title="Search"
              type="button"
              id="searchbtn-addon"
              @click="loadFoundRoom"
            >
              <i class="bx bx-search align-middle"></i>
            </button>
          </div>
        </form>
        <!-- Results -->
        <div class="chat-message-list col-10 text-body">
          <div class="list-group">
            <div
              v-for="(item, index) in result"
              :key="index"
              :id="'contact-id-' + item.uid"
            >
              <router-link
                type="button"
                class="list-group-item list-group-item-action"
                v-if="item.username"
                :to="{
                  name: 'visitProfile',
                  params: { username: item.username },
                }"
                custom
                v-slot="{ navigate }"
              >
                <span
                  role="link"
                  class="nav-link py-2 ps-2"
                  @click="navigate"
                  aria-current="true"
                  @keypress.enter="navigate"
                >
                  <i class="fa-solid fa-user me-3 text-primary"></i>
                  <span class="font-size-16 text-truncate">{{
                    item.username
                  }}</span>
                </span>
              </router-link>
              <router-link
                v-else
                :to="{ name: 'Room', params: { id: item.uid } }"
                type="button"
                class="list-group-item list-group-item-action"
                custom
                v-slot="{ navigate }"
              >
                <div
                  role="link"
                  @click="navigate"
                  class="d-flex align-items-center list-rooms-link_pointer"
                  @keypress.enter="navigate"
                >
                  <div class="overflow-hidden" title="Topic">
                    <i class="fa-solid fa-book-bookmark me-3 text-primary"></i>
                    <span class="font-size-16 text-truncate">
                      {{ item.title }}
                    </span>
                  </div>
                  <div class="ms-auto" title="Messages">
                    <span class="badge text-muted rounded-pill">
                      {{ item.count }}</span
                    >
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Search",

  data() {
    return {
      myrooms: undefined,
      serach: "",
      result: undefined,
    };
  },

  mounted() {
    this.$nextTick(() => {});
  },
  methods: {
    test() {
      document.querySelector(".user-chat").classList.remove("user-chat-show");
    },
    loadFoundRoom() {
      event.preventDefault();
      if (this.serach.length > 1) {
        this.$store.state.modules.api
          .getSearchUnits("uid", 0, 100, this.serach)
          .then((resp) => {
            if (resp.status == 200) {
              this.result = resp.data.units;
              console.log(this.result);
            } else {
              this.result = undefined;
            }
          })
          .catch((err) => {});
      }
    },
  },
};
</script>
